import { LS_USER_INFO } from './localStorage'
import type { TFunction } from 'i18next'
import { getLocalStorage } from 'utils/helpers/common'

export const optionsFacility = ({
  companyName = '',
  financialMonth,
}: IGetCompanyInfo) => {
  const userInfo = getLocalStorage(LS_USER_INFO)
  const companyInfo = userInfo?.company

  const branchInfo = userInfo?.branches?.map(
    (branch: any) => branch?.branchName?.jp,
  )
  return [
    {
      value: companyInfo?.code || '',
      label: 'company.code',
    },
    {
      value: companyName || companyInfo?.companyName?.jp,
      label: 'setting.branch.company',
    },
    {
      value: branchInfo || [],
      label: 'setting.branch.branch',
    },
    {
      value: financialMonth ?? '',
      label: 'company.fiscal_year_start_month',
    },
  ]
}

export const defaultOption: IOption = {
  value: '',
  label: 'base.option_default.all',
}

export const optionsSearchEmission = () => {
  const userInfo = JSON.parse(localStorage.getItem(LS_USER_INFO) ?? '')
  const branchInfo = userInfo.branch
  return {
    countries: [
      {
        label: branchInfo?.division?.company?.country?.countryName?.jp || '',
        value: branchInfo?.division?.company?.country?.id || '',
      },
    ],
    companies: [
      {
        label: branchInfo?.division?.company?.companyName?.jp || '',
        value: branchInfo?.division?.company?.id || '',
      },
    ],
    divisions: [
      {
        label: branchInfo?.division?.divisionName?.jp || '',
        value: branchInfo?.division?.id,
      },
    ],
    branches: [
      {
        label: branchInfo?.branchName?.jp || '',
        value: branchInfo?.id || '',
      },
    ],
    branchId: branchInfo?.id || '',
  }
}

export const SHARE_DATA_STATUS = {
  REQUESTED: 1,
  SHARED: 2,
  STOP: 3,
}

export const getDefaultOptionAll = (t: TFunction): IOption => ({
  value: '',
  label: t('base.option_default.all'),
})
